module.exports = __webpack_public_path__ + "media/img/virtual-internships/company-testimonial-leiho-2e26ecb11fe191e345848995330e39ff.png";